export default __webpack_public_path__ + "static/media/head03_zh_tw_sp.bb875009.png";